// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-bb38dd48]{border-collapse:collapse}table[data-v-bb38dd48],td[data-v-bb38dd48],th[data-v-bb38dd48]{border:.5px solid #000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
